<template>
    <b-modal ref="user-card-modal" @ok="userCardModalOk">
      <template v-slot:modal-header="{}">
        <div>{{ $store.state.localization.data.mainPage.scfgUsers.pageLabel }}</div>
      </template>
      <div style="font-size: 13px">
        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.scfgUsers.tableColumns.name"
          label-for="input-horizontal"
        >
          <b-form-input
            v-model="name"
            :state="isUserNameValid"
            style="font-size: 13px"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label-cols-sm="4"
          label-cols-lg="3"
          content-cols-sm
          content-cols-lg="8"
          :label="$store.state.localization.data.mainPage.scfgUsers.tableColumns.type"
          label-for="input-horizontal"
        >
          <b-form-select
            v-model="type"
            :state="isTypeValid"
            :options="typeOptions"
            style="font-size: 13px"
          ></b-form-select>
        </b-form-group>

        <div
            class="row no-gutters"
            style="margin-left: 5px; margin-bottom: 5px"
          >
            <div class="col-5">
              <b-form-select
                v-model="roles.left.data"
                :options="roles.left.values"
                multiple
                :select-size="12"
                style="font-size: 12px"
                ref="rolesLeftRef"
              ></b-form-select>
            </div>
            <div class="col-1 align-self-center" style="text-align: center">
              <b-button-group vertical>
                <b-button
                  size="sm"
                  style="font-size: 12px"
                  variant="success"
                  @click="selectRoles"
                  >&#62;</b-button
                >
                <b-button
                  size="sm"
                  style="font-size: 12px"
                  variant="success"
                  @click="selectAllRoles"
                  >&#62;&#62;</b-button
                >
                <b-button
                  size="sm"
                  style="font-size: 12px"
                  variant="success"
                  @click="deselectAllRoles"
                  >&#60;&#60;</b-button
                >
                <b-button
                  size="sm"
                  style="font-size: 12px"
                  variant="success"
                  @click="deselectRoles"
                  >&#60;</b-button
                >
              </b-button-group>
            </div>
            <div class="col-5">
              <b-form-select
                v-model="roles.right.data"
                :options="roles.right.values"
                multiple
                :select-size="12"
                style="font-size: 12px"
                :state="isSettingsValid"
                ref="rolesRightRef"
              ></b-form-select>
            </div>
          </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" style="font-size: 12px" @click="ok()">{{
          $store.state.localization.data.common.table.ok
        }}</b-button>
        <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
          $store.state.localization.data.common.table.cancel
        }}</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import { scfgService } from "../../../services";
  
  export default {
    name: "UpdateScfgUserPage",
    components: {},
    data() {
      return {
        id: null,
        name: null,
        type: null,
        isIdValid: null,
        isUserNameValid: null,
        isSettingsValid: null,
        isTypeValid: null,
        roles: {
          left: {
            data: [],
            values: [],
          },
          right: {
            data: [],
            values: [],
          },
        },
      };
    },
    computed: {
      typeOptions() {
        const typeOptions = [];

        for (
          let i = 0;
          i <
          this.$store.state.localization.data.mainPage.scfgUsers.typeOptions
            .length;
          i++
        ) {
          typeOptions.push({
            value:
              this.$store.state.localization.data.mainPage.scfgUsers.typeOptions[
                i
              ].key,
            text: this.$store.state.localization.data.mainPage.scfgUsers
              .typeOptions[i].value,
          });
        }
        return typeOptions;
      },
    },
    methods: {
      async open(user, roles) {
        this.isTypeValid = null;
        this.isSettingsValid = null;
        
        this.id = user.id;
        this.name = user.name;
        this.type = user.type;

        this.roles.left.data = [];
        this.roles.left.values = [];
        this.roles.right.data = [];
        this.roles.right.values = [];

        for (let i = 0; i < roles.length; i++) {
          const role = user.settings.find(
            (x) => x == roles[i].id
          );
          if (role) {
            this.roles.right.values.push({
              value: roles[i].id,
              text: roles[i].name,
            });
          } else {
            this.roles.left.values.push({
              value: roles[i].id,
              text: roles[i].name,
            });
          }
        }

        this.$refs["user-card-modal"].show();
      },
      validate() {
        let isValid = true;

        if (!this.name) {
          this.isUserNameValid = false;
          isValid = false;
        } else {
          this.isUserNameValid = null;
        }

        const type = parseInt(this.type);

        if (isNaN(type)) {
          this.isTypeValid = false;
          isValid = false;
        } else {
          this.isTypeValid = null;
        }

        if (this.roles.right.values.length == 0) {
          this.isSettingsValid = false;
          isValid = false;
        } else {
          this.isSettingsValid = null;
        }
  
        return isValid;
      },
      selectRoles() {
        for (let i = 0; i < this.roles.left.data.length; i++) {
          const columnIndex = this.roles.left.values.findIndex(
            (x) => x.value == this.roles.left.data[i]
          );

          this.roles.right.values.push(
            this.roles.left.values[columnIndex]
          );
          this.roles.left.values.splice(columnIndex, 1);
        }
      },
      selectAllRoles() {
        for (let i = 0; i < this.roles.left.values.length; i++) {
          this.roles.right.values.push(
            this.roles.left.values[i]
          );
        }

        this.roles.left.data = [];
        this.roles.left.values = [];
      },
      deselectRoles() {
        for (let i = 0; i < this.roles.right.data.length; i++) {
          const columnIndex = this.roles.right.values.findIndex(
            (x) => x.value == this.roles.right.data[i]
          );

          this.roles.left.values.push(
            this.roles.right.values[columnIndex]
          );
          this.roles.right.values.splice(columnIndex, 1);
        }
      },
      deselectAllRoles() {
        for (let i = 0; i < this.roles.right.values.length; i++) {
          this.roles.left.values.push(
            this.roles.right.values[i]
          );
        }

        this.roles.right.data = [];
        this.roles.right.values = [];
      },
      getRoles() {
        const roles = [];

        for (let i = 0; i < this.roles.right.values.length; i++) {
          roles.push(this.roles.right.values[i].value);
        }

        return roles;
      },
      async userCardModalOk(event) {
        if (!this.validate()) {
          event.preventDefault();
          return;
        }
  
        const userCard = {
          id: this.id,
          name: this.name,
          type: parseInt(this.type),
          settings: this.getRoles()
        };
  
        const updateUserResponse = await scfgService.updateUser(userCard);
  
        if (
          updateUserResponse.isSuccess &&
          updateUserResponse.data &&
          updateUserResponse.data.countUpdatedRows == 1
        ) {
          this.$emit("userUpdatedSuccessEvent", userCard);
        } else {
          this.$emit("userUpdatedFailEvent");
        }
      },
    },
  };
  </script>
  